export async function saveObjectInLS<T>(key: string, data: T): Promise<void> {
  localStorage.setItem(key, JSON.stringify(data));
}

export async function saveStringInLS(
  key: string,
  value: string,
): Promise<void> {
  localStorage.setItem(key, value);
}

export async function getObjectInLS<T>(key: string): Promise<T | undefined> {
  const data = localStorage.getItem(key);
  if (!data) {
    return undefined;
  }

  try {
    return JSON.parse(data) as T;
  } catch {
    return undefined;
  }
}

export function getStringInLS(key: string): string | undefined {
  return localStorage.getItem(key) ?? undefined;
}

export function existsInLS(key: string): boolean {
  return localStorage.getItem(key) !== null;
}

export async function deleteInLS(key: string): Promise<void> {
  localStorage.removeItem(key);
}
